import { render } from "./sidebar.html?vue&type=template&id=1fa09677&scoped=true&external"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.css?vue&type=style&index=0&id=1fa09677&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa09677"]])

export default __exports__